module.exports = __webpack_public_path__ + "img/setting.d318ee62.png";